import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from '@/router'
import store from './store/store'
import i18n from './i18n'
import JsonExcel from "vue-json-excel";
import PageHeader from "@/components/PageHeader/PageHeader";

// Self-hosted fonts and icons
import '@mdi/font/css/materialdesignicons.css';

// Skala taip dikongsi (token --fs-*). Lihat src/styles/typography.css.
import './styles/typography.css';

// Lalai fon graf. Teks canvas tidak mewarisi CSS, jadi saiznya ditetapkan
// melalui Chart.js — lihat src/plugins/chart.js.
import './plugins/chart';

// Self-hosted XLSX
import * as XLSX from 'xlsx';
window.XLSX = XLSX;

Vue.component("downloadExcel", JsonExcel);
Vue.component("PageHeader", PageHeader);
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  // BM sahaja buat masa ini: butang Switchlang disembunyikan dalam MenuHeader,
  // jadi kunci locale kepada 'bm' walaupun URL mengandungi /en/ (pautan lama
  // atau penanda buku). Untuk mengaktifkan semula bahasa, pulangkan baris
  // `to.params.lang` di bawah dan nyahkomen <Switchlang> dalam MenuHeader.vue.
  i18n.locale = 'bm'
  next()
})
new Vue({
  i18n,
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
